import { createApp } from '@app/adapters/create-app'
import ShareTrigger from '@app/application/pulse-share/share-trigger.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const elements = doc.querySelectorAll<HTMLElement>(
    "[data-behaviour='share-trigger']"
  )

  elements.forEach((element) => {
    const { ledgerId, objectId, isBlockedInitial, sharedObjectName } =
      element.dataset

    createApp(ShareTrigger, {
      ledgerId: Number(ledgerId),
      objectId: Number(objectId),
      isBlockedInitial: isBlockedInitial === 'true',
      sharedObjectName,
    }).mount(element)
  })
})
